import React, { useState, useEffect } from "react";
import { Badge, Spinner } from "react-bootstrap";
import { getSpecificUsersMissingTimecards } from "../Api/DailyTimeCard";
import { toast } from "react-toastify";

const DailyTimecardsReport = () => {
  const [usersData, setUsersData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getSpecificUsersMissingTimecards();
        if (response.data && response.data.length) {
          // Filter out users with 0 missing days
          const filteredData = response.data.filter(user => user.missingDaysCount > 0);
          setUsersData(filteredData);
        }
      } catch (error) {
        console.error("Error fetching daily timecards:", error);
        toast.error("Failed to load daily timecards data");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <div className="text-center py-3">
        <Spinner animation="border" size="sm" />
      </div>
    );
  }

  if (!usersData.length) {
    return <div className="text-muted small">All daily timecards are up to date</div>;
  }

  const minCount = Math.min(...usersData.map(u => u.missingDaysCount));
  const maxCount = Math.max(...usersData.map(u => u.missingDaysCount));

  return (
    <div className="d-flex flex-wrap justify-content-center gap-1 p-1">
      {usersData.map((user) => {
        const fontSize = 12 + ((user.missingDaysCount - minCount) / (maxCount - minCount || 1)) * 16;
        const isTopUser = user.missingDaysCount === maxCount;

        return (
          <Badge
            key={user.username}
            pill
            bg={isTopUser ? "danger" : "secondary"}
            className="m-1"
            style={{
              fontSize: `${fontSize}px`,
              cursor: "pointer",
              transition: "all 0.3s ease",
              padding: "4px 8px",
            }}
            title={`${user.username}: ${user.missingDaysCount} pending`}
          >
            {user.username} ({user.missingDaysCount})
          </Badge>
        );
      })}
    </div>
  );
};

export default DailyTimecardsReport;